var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1748_25146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5238 20.475V2.02748C79.5238 1.43105 79.0384 0.952393 78.4422 0.952393H59.8829C49.0324 0.952393 40.2381 9.6937 40.2381 20.4788C40.2381 9.6937 31.4438 0.952393 20.5933 0.952393H2.034C1.43396 0.952393 0.952393 1.43485 0.952393 2.02748V20.475C0.952393 31.2601 9.74667 40.0014 20.5972 40.0014C9.74667 40.0014 0.952393 48.7428 0.952393 59.5279V77.9754C0.952393 78.5718 1.43778 79.0505 2.034 79.0505H20.5933C31.4438 79.0505 40.2381 70.3092 40.2381 59.5241C40.2381 70.3092 49.0324 79.0505 59.8829 79.0505H78.4422C79.0423 79.0505 79.5238 78.568 79.5238 77.9754V59.5279C79.5238 48.7428 70.7295 40.0014 59.8791 40.0014C70.7295 40.0014 79.5238 31.2601 79.5238 20.475ZM40.2381 59.5241C40.2381 48.739 31.4438 39.9976 20.5933 39.9976C31.4438 39.9976 40.2381 31.2563 40.2381 20.4712C40.2381 31.2563 49.0324 39.9976 59.8829 39.9976C49.0324 39.9976 40.2381 48.739 40.2381 59.5241Z",
    fill: "#C3A5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1748_25146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsIcon1);
export default __webpack_public_path__ + "static/media/BSIcon1.647a69751ee734121b078626292a0640.svg";
export { ForwardRef as ReactComponent };